import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {StandaloneComponent} from '../standalone.component';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenticationInfoService} from '../authentication-info.service';
import {AppConstants} from '../AppConstants';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';


const _ = (s) => s;


@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PageNotFoundComponent extends StandaloneComponent implements OnInit {
  userAuthenticated = false;
  page: string;
  constructor(
    route: ActivatedRoute,
    router: Router,
    hostElement: ElementRef,
    private translate: TranslateService,
    private authnInfoService: AuthenticationInfoService,
  ) {
    super(route, router, hostElement);
  }

  ngOnInit() {
    super.init();
    this.page = this.router.url
      .replace(/(\W)/g, '<wbr />$1');

    this.authnInfoService.sessionInfo.subscribe(sessnInfo => {
      this.userAuthenticated = sessnInfo.fullyAuthenticated;
    });
  }

  getContinueLink(): string {
    let retVal: string;
    if (this.userAuthenticated) {
      retVal = AppConstants.PATH_PROFILE;
    } else {
      retVal = AppConstants.PATH_LOGIN;
    }
    return retVal;
  }

  public resolveWindowTitlePart(): Observable<string|undefined> {
    return this.translate.get('page-not-found.window-title');
  }
}
